<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-row>
          <v-col cols="12">
            <v-select
              filled
              data-cy="FormAccount-accountType"
              :label="$$t('accountType')"
              v-model="localAccount.accountType"
              :items="accountTypes"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              filled
              data-cy="FormAccount-code"
              :label="$$t('code')"
              v-model="localAccount.code"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              filled
              data-cy="FormAccount-name"
              :label="$$t('name')"
              v-model="localAccount.name"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              filled
              data-cy="FormAccount-description"
              :label="$$t('description')"
              v-model="localAccount.description"
            />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormAccount-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormAccount-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import accountTypes from './accountTypes.json';

export default {
  name: 'FormAccount',
  module: 'Account',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    Account: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      accountTypes,
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localAccount
      */
      localAccount: {},
    };
  },
  watch: {
    Account() {
      this.localAccount = this.Account;
    },
  },
  created() {
    this.localAccount = this.Account;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localAccount);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormAccount example

'''js
<FormAccount :Account="Account" />
'''
</docs>
